import { FormEvent, useState } from 'react';
import { api } from '../api';
import { useSession } from '../session';
import { ErrorBox, Field, useAsync } from '../components/ui';

export function LoginPage() {
  const s = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const a = useAsync();
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    const ok = await a.run(() => api('/auth/login', { method: 'POST', body: { email, password }, entity: false }));
    if (ok) await s.reload();
  };
  return (
    <div className="login">
      <form className="card" onSubmit={submit}>
        <h1>BrunoCRM</h1>
        <Field label="E-mail-cím"><input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus /></Field>
        <Field label="Jelszó"><input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
        <ErrorBox error={a.error} />
        <button type="submit" disabled={a.busy}>Belépés</button>
      </form>
    </div>
  );
}
